import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { components } from 'react-select';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faUsers } from '@fortawesome/pro-solid-svg-icons';

import SelectFilter from './select_filter';
import { getBrokers } from 'components/users/api';
import { mapId, mapName } from 'helpers/react_select_helpers';

const Broker = ({ data }) => (
  <div className={`profile-name ${data.imageUrl ? 'py-0' : ''}`}>
    {data.imageUrl ? (
      <img className="img-circle profile-image-tiny" src={data.imageUrl} />
    ) : (
      <FontAwesomeIcon className="text-muted profile-image-tiny ml-1" icon={faUsers} size="lg" />
    )}
    {data.name}
  </div>
);

const Option = ({ data, ...props }) => (
  <components.Option {...props}>
    <Broker data={data} />
  </components.Option>
);

const SingleValue = ({ data, ...props }) => (
  <components.SingleValue {...props}>
    <Broker data={data} />
  </components.SingleValue>
);

const BrokerFilter = ({ brokers, newDesignSystem = false, selectedBrokerId, onChange, onClear, ...props }) => {
  const [loadedBrokers, setLoadedBrokers] = useState();

  React.useEffect(() => {
    if (!brokers) {
      getBrokers().then(({ brokers }) => {
        setLoadedBrokers(brokers);
      });
    }
  }, []);

  brokers = brokers || loadedBrokers;
  if (!brokers) return null;

  return (
    <SelectFilter
      className="broker-filter-select"
      componentOverrides={{ Option, SingleValue }}
      defaultValue={brokers[0]}
      getOptionLabel={mapName}
      getOptionValue={mapId}
      name="broker-filter"
      newDesignSystem={newDesignSystem}
      options={brokers}
      value={selectedBrokerId ? brokers.find(broker => broker.id === selectedBrokerId) : brokers[0]}
      onChange={onChange}
      onClear={onClear}
      {...props}
    />
  );
};

BrokerFilter.propTypes = {
  brokers: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    imageUrl: PropTypes.string,
    name: PropTypes.string
  })),
  newDesignSystem: PropTypes.bool,
  selectedBrokerId: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  onChange: PropTypes.func.isRequired,
  onClear: PropTypes.func
};

const dataPropTypes = {
  data: PropTypes.object
};

Broker.propTypes = dataPropTypes;
Option.propTypes = dataPropTypes;
SingleValue.propTypes = dataPropTypes;

export default BrokerFilter;
